'use client'
import { useRef } from 'react';
import { createDynamicClient } from '@dynamic-labs-sdk/client';
import { registerExtension } from '@dynamic-labs-sdk/client/core';
import { setDynamicClient } from '../../../client.js';
import { CLIENT_EXTENSION_NAME } from '../../constants.js';
import { fetchOverride } from './fetchOverride/fetchOverride.js';
import { syncEvents } from './syncEvents/syncEvents.js';

const useInitializeSdkClient = ({ settings }) => {
    const lastClientDependencyKey = useRef(null);
    const clientDependencyKey = [
        settings.apiBaseUrl,
        settings.environmentId,
    ].join('-');
    if (lastClientDependencyKey.current === clientDependencyKey)
        return;
    lastClientDependencyKey.current = clientDependencyKey;
    const newClient = createDynamicClient({
        coreConfig: { apiBaseUrl: settings.apiBaseUrl, fetch: fetchOverride },
        environmentId: settings.environmentId,
    });
    setDynamicClient(newClient);
    registerExtension(newClient, CLIENT_EXTENSION_NAME);
    syncEvents(newClient);
};

export { useInitializeSdkClient };
